import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button
} from "@material-ui/core";
import Axios from "axios";
import MaterialTable from "material-table";

import { forwardRef } from "react";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const datetimeFormat = "yyyy/MM/dd HH:mm:ss";
const orderDefault = {
  aaHnNo: "",
  result: "",
  msg: "",
  chargeLog: []
};


// API
const orderChargeURL = "/api/order/getOrderChargeInfoByHn";

export default function ChargeModalByHn(props) {
  const [modalStatus, setModalStatus] = useState(false);
  const closeModal = props.closeModal;
  const [order, setOrder] = useState(orderDefault);
  const [orderChargeLog, setOrderChargeLog] = useState([])


  useEffect(() => {
    if (props.open) {
      // console.log("ChargeModal effect");
      getOrderCharge(props.hn);
    }
    setModalStatus(props.open);
  }, [props.open, props.hn]);

  const getOrderCharge = hn => {
    console.log(typeof (hn));
    Axios.post(orderChargeURL, { "Hn": hn }).then(response => {
      console.log(response.data);
      setOrder(response.data);
      setOrderChargeLog(response.data.chargeLog ? response.data.chargeLog : [])
    }).catch(function (err) { console.log(err) });
  };

  return (
    <Dialog
      open={modalStatus}
      onClose={closeModal}
      maxWidth="lg"
      scroll="paper"
    >
      <Box>
        <DialogTitle>訂單出帳紀錄</DialogTitle>
        <Typography variant="h5"></Typography>
        <DialogContent dividers>
          <Typography>
            訂單管理人員透過下列表單修改該訂單的狀態與付款情形，由於商城提供消費者透過前端頁面查詢自己的購買紀錄，因此請管理人員必須依照實際情況限期處理。
          </Typography>
          <Typography>
            特別提醒：訂單狀態與付款情形也與會員的紅利點數計算有關。
          </Typography>
        </DialogContent>
        <DialogTitle>付款狀態</DialogTitle>
        {/* <Typography variant="h5">付款狀態</Typography> */}
        <DialogContent dividers>
          <Grid container>
            {tableCell("HN帳號：", order.aaHnNo)}
          </Grid>
        </DialogContent>
        <DialogTitle>出帳紀錄</DialogTitle>
        {/* <Typography variant="h5">出帳紀錄</Typography> */}
        <DialogContent dividers>{chargeTable(orderChargeLog)}</DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="primary">
            離開
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

function tableCell(title, value) {
  return (
    <Grid item xs={12} md={6}>
      <Grid container>
        <Grid item xs={4}>
          {title}
        </Grid>
        <Grid item xs={8}>
          {value}
        </Grid>
      </Grid>
    </Grid>
  );
}

function chargeTable(chargeLog) {
  const columns = [
    { title: "訂單編號", field: "orderNo" },
    {

      title: "訂單時間",
      field: "chargeDate",
      render: rowData => format(new Date(rowData.orderStartDate), datetimeFormat)
    },
    {

      title: "啟用時間",
      field: "orderStartDate",
      render: rowData => format(new Date(rowData.orderStartDate), datetimeFormat)
    },
    {

      title: "出帳時間",
      field: "chargeDate",
      render: rowData => format(new Date(rowData.chargeDate), datetimeFormat)
    },
    { title: "帳號數", field: "quantity" },
    { title: "出帳金額", field: "chargeAmount" },
    { title: "註記aaa_tag", field: "aaaTag" },
    { title: "報帳狀態", field: "aaaStatus" },
    { title: "OTPW", field: "otpw" }
  ];
  return (
    <MaterialTable
      icons={tableIcons}
      columns={columns}
      data={chargeLog}
      options={{
        search: false,
        paging: false,
        showTitle: false,
        toolbar: false,
        padding: "dense",
        rowStyle: rowData => ({
          backgroundColor: rowData.tableData.id % 2 ? "#FFFFFF" : "#EEEEEE"
        })
      }}
    />
  );
}
